import { use, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { ApiConnectItemDb, ApiConnectItemDbList, ApiConnectItemDbWord } from "../../api/LionsUserApiConect";
import { useForm } from "react-hook-form";
import PopUpWarning, { PopUpCaller } from "../../PopUpWarning/PopUpWarning";
import { TipMouseOutEvent, TipMouseOverEvent } from "../../Tooltip/Tooltip";
import CloudFlareTurnstile from "../../CloudFlareTurnstile/CloudFlareTurnstile";
import { CardBmpMap } from "./itemList/CardBmpMap";
import { PageContext } from "../../Context/PageContext";
import { OpenPopMenu } from "../../PopMenuWindow/PopMenuWindow";
import OpenSlot from "./img/comparison_empty_card_slot.bmp"
import ClosedSlot from "./img/comparison_disable_card_slot.bmp"
import ItemUsable from "./img/usable2.bmp"
import ItemRops from "./img/rops2.bmp"
import ItemArmor from "./img/armor2.bmp"
import ItemWeapon from "./img/weapon2.bmp"
import ItemVisual from "./img/visual2.bmp"
import ItemAmmo from "./img/ammo2.bmp"
import ItemCard from "./img/card2.bmp"
import ItemEtc from "./img/etc2.bmp"
import ItemAll from "./img/allitens.png"
import MobShowToolTip, { MobTipMouseOutEvent, MobTipMouseOverEvent } from "./MobShowToolTip";
import MonsterMap from "./Monsters";
import {MapaMonstro} from "./mobList/MapaMonstro";
import Magnifer from "./img/lupa.png"
import ElementalFilter from "./filters/ElementalFilter";
import TypeFilter from "./filters/TypeFilter";
import SubTypeFilter from "./filters/SubtypeFilter";
import AtributeFilter from "./filters/AtributeFilter";
import ArmorFilter from "./filters/ArmorFilter";
import { MobListRepoComplete, MobListRepoConsult } from "./mobList/mobListRepo";
import { MobDropListConsult } from "./mobList/monsterdrops";
import { ItemAegisToIdConsult } from "./mobList/itemMapAegisToID"
import { ItemIdToNameAndResourceConsult } from "./mobList/itemMapIdToNameAndResourceName";
import { RadarChart } from '@mui/x-charts/RadarChart';
import DemoRadarVisualisation from './mobList/RadarChart'
import MvpType from "./img/montype_mvp.png"
import BossType from "./img/montype_boss.png"
import { MvpDropListConsult } from "./mobList/monstermvpdrops";

var InvalidEntry = "Valor digitado é invalido. Por favor, digite somente palavras sem caracteres especiais ou apenas o Id do item desejado.";

function MobsDatabase() {

    let searchAmplitude = 20;

    const {setToolTipContent, setPopMenuContent} = useContext(PageContext)

    const [itemDbList, setItemDbList] = useState([])

    const [filteredList, setFilteredList] = useState([])
    const [partionedList, setPartionedList] = useState([])

    const [nadaEncontrado, setNadaEncontrado] = useState('')
    const [monsterDropList, setMonsterDropList] = useState([])
    const [mvpDropList, setMvpDropList] = useState([])
    const [mobTypeIcon, setMobTypeIcon] = useState()

    const [tFilter, setTFilter] = useState("")
    const [typeDescriptionFilter, setTypeDescriptionFilter] = useState("Todos os tipos")

    const [stFilter, setStFilter] = useState(SubTypeFilter)
    const [pFilter, setPFilter] = useState(ElementalFilter)
    const [aFilter, setAFilter] = useState(AtributeFilter)
    const [armFilter, setArmFilter] = useState(ArmorFilter)

    const [subTypeFilter, setSubTypeFilter] = useState("")
    const [propertyFilter, setPropertyFilter] = useState("")
    const [atributeFilter, setAtributeFilter] = useState(["",""])

    const [raceFilter, setRaceFilter] = useState("")
    const [elementFilter, setElementFilter] = useState("")
    const [classMobFilter, setClassMobFilter] = useState("")

    const [equipFilter, setEquipFilter] = useState("")

    const [selectedInterval, setSelectedInterval] = useState(1)
    const [amountOfIntervals, setAmountOfIntervals] = useState(0)
    const [paginationList, setPaginationList] = useState([<IntervalPartition>0</IntervalPartition>])
    const [resultsFounds, setResultsFounds] = useState(0)

    const [btnActive, setBtnActive] = useState()

    const [mobList, setMobList] = useState([])
    
    const { register, getValues } = useForm();


    function formatNumber(number) {

        if(number == null) {
            return(0)
        }

        const formatado = number.toLocaleString('pt-BR');

        return(formatado)
    }


    function styleToggleFilterButton(e) {

        Array.from(e.target.parentNode.children).map((item) => {
            item.style.filter = 'saturate(0)';
            item.style.scale = '1.0';
        });

        e.target.style.filter = 'saturate(1)';
        e.target.style.scale = '1.2';
    }

    function hasCorruptedCharacters(str) {
    
        const corruptedPattern = /[^a-zA-Z0-9_.]/;
        return corruptedPattern.test(str);
    }
    

    function CheckCorrupted(key) {
      const originalValue = key;
    
      if (!originalValue) {
        return undefined;
      }
      
      if (hasCorruptedCharacters(originalValue)) {
        return originalValue;
      } else {
        return originalValue.toLowerCase();
      }
    }


    document.addEventListener('keydown', (event) =>{
          if(event.keyCode === 13) {
          }
        })


    function PartionedList() {

        let splitedList = [];

        let interval = selectedInterval;

        let start = (interval-1)*searchAmplitude;

        let end = start + searchAmplitude;

        if(filteredList.length < end) {
            end = filteredList.length;
        }

        for(let i = start ; i < end; i++) {
            splitedList.push(filteredList[i])

        }

        setPartionedList(splitedList)
    }



    function searchMob() {

        let tempFilteredList = [];

            for(let i = 0; i < mobList.length; i++) {

                    let result = MobListRepoConsult(mobList[i]).Name.toLowerCase();
                    let race = MobListRepoConsult(mobList[i]).Race;
                    let element = MobListRepoConsult(mobList[i]).Element;

                    if(race == null) {
                        race = "";
                    }

                    if(element == null) {
                        element = "";
                    }

                    if(result.includes(getValues('InputChave').toLowerCase()) &&
                    race.includes(raceFilter) &&
                    element.includes(elementFilter))
                     {
                        if(classMobFilter != "") {

                            if(classMobFilter == "null" && MobListRepoConsult(mobList[i]).Class != null) {
                                continue
                            }

                            if(classMobFilter == "Boss" && MobListRepoConsult(mobList[i]).Class != "Boss"){
                                continue
                            }
                        }

                        //itemDbList[i].identifiedDescriptionName.includes(propertyFilter) &&

                       //(itemDbList[i].identifiedDescriptionName.includes(atributeFilter[0]) || itemDbList[i].//identifiedDescriptionName.includes(atributeFilter[1])) &&

                       // itemDbList[i].identifiedDescriptionName.includes(statusFilter) &&
                       // itemDbList[i].identifiedDescriptionName.includes(equipFilter)) {

                        tempFilteredList.push(mobList[i]);
                    }

                }

        setResultsFounds(tempFilteredList.length);
        setFilteredList(tempFilteredList);
    }

    function resetarScroll() {
    // Rola para as coordenadas X=0 e Y=0
    window.scrollTo(0, 800);
    }


    useEffect(() => {

        let initialMobList = Object.keys(MobListRepoComplete());
        setMobList(initialMobList);

        setTimeout(() => {
            document.getElementById('DatabaseMaster').style.opacity = "1";
        }, 300);
    },[]);

    useEffect(() => {setResultsFounds(mobList.length)}, [mobList])
    useEffect(() => {setAmountOfIntervals(resultsFounds/searchAmplitude)}, [resultsFounds])
    useEffect(() => {

            searchMob();
            let list = []
    
                if(amountOfIntervals >= 1){
    
                for(let i = 1; i <= Math.ceil(amountOfIntervals); i++)
                {
                    list.push(<IntervalPartition onClick={() => setSelectedInterval(i)}>{i}</IntervalPartition>)
                }
    
                } else {
                    list.push(<IntervalPartition>1</IntervalPartition>)
                }
                
            setPaginationList(list);

        },[amountOfIntervals]);

    useEffect(() => {

        if(selectedInterval > resultsFounds/searchAmplitude+1) {
            setSelectedInterval(1)
        }
        
        PartionedList()}, [selectedInterval, filteredList])
    useEffect(() =>{ searchMob()},[raceFilter, elementFilter, classMobFilter])
;
    return(
        <DatabaseContainer>
            <TitleContainer>
                
                <SearchBarContainer>

                <Input
                placeholder='Palavra-chave ou Nome do Monstro' 
                {...register('InputChave')}/>

                <Submit onClick={() => searchMob()}>
                    <SubmitIcon img={Magnifer} />
                </Submit>

                </SearchBarContainer>
                     
            </TitleContainer>

            <SubTypeBarContainer>

                <FilterSelect name="RaceFilter"
                    {...register('RaceFilter', {
                         onChange: (e) => {
                            setRaceFilter(e.target.value);
                            if(e.target.value == ""){
                                setTypeDescriptionFilter("Todos os tipos");
                                return
                            }
                            setTypeDescriptionFilter(e.target.value);
                        }
                    })}>
                    <option value="">Tipo</option>
                    <option value="Plant">Planta</option>
                    <option value="Insect">Inseto</option>
                    <option value="Brute">Bruto</option>
                    <option value="Fish">Peixe</option>
                    <option value="Undead">Zumbi</option>
                    <option value="Demihuman">Humanoide</option>
                    <option value="Formless">Amorfo</option>
                    <option value="Demon">Demônio</option>
                    <option value="Angel">Anjo</option>

                </FilterSelect>

                <FilterSelect name="ElementFilter"
                    {...register('ElementFilter', {
                         onChange: (e) => {
                            setElementFilter(e.target.value);
                        }
                    })}>
                    <option value="">Elemento</option>
                    <option value="Fire">Fogo</option>
                    <option value="Water">Água</option>
                    <option value="Wind">Vento</option>
                    <option value="Earth">Terra</option>
                    <option value="Holy">Sagrado</option>
                    <option value="Undead">Maldito</option>
                    <option value="Dark">Sombrio</option>
                    <option value="Ghost">Fantasma</option>

                </FilterSelect>

                <FilterSelect name="MobTypeFilter"
                    {...register('MobTypeFilter', {
                         onChange: (e) => {
                            setClassMobFilter(e.target.value);
                        }
                    })}>
                    <option value="">Classe</option>
                    <option value="null">Normal</option>
                    <option value="Boss">Chefe</option>

                </FilterSelect>

            </SubTypeBarContainer>

            <PaginationContainer>
                 {paginationList}
            </PaginationContainer>

            <PaginationContainerIncrementer>
                 <IntervalPartitionIncrementer onClick={() => {
                    if(selectedInterval == 1) {
                        return
                    } else {
                        setSelectedInterval(selectedInterval - 1)
                    }
                    }}> ← 
                </IntervalPartitionIncrementer>
                <IntervalPartitionIncrementer onClick={() => {
                    if(selectedInterval > amountOfIntervals) {
                        return
                    } else {
                        setSelectedInterval(selectedInterval + 1)
                    }
                    }}> →
                </IntervalPartitionIncrementer>
            </PaginationContainerIncrementer>

            <MiddleContainer>
                <PopUpWarning />
                <H3>Intervalo: {selectedInterval}</H3>
                <H2>{typeDescriptionFilter}</H2>
                <H1>{resultsFounds} resultados encontrados</H1>
            </MiddleContainer>

            <MobListMasterContainer>

                {nadaEncontrado}

                {partionedList.map((mob) => {

                    let Icon;
                    let typeTip = "Monstro comum";

                    if(MobListRepoConsult(mob).MvpExp != null) {
                        Icon = MvpType;
                        typeTip = "MVP";

                    }

                    if(MobListRepoConsult(mob).MvpExp == null && MobListRepoConsult(mob).Class == 'Boss') {
                        Icon = BossType;
                        typeTip = "Mini-boss"
                    }
                    

                    return(
                    <RoMobMasterContainer>
                    <RoMobHeader>
                        <RoMobName>
                            <RoMobEnglishName>{MobListRepoConsult(mob).Name}</RoMobEnglishName>
                            <RoMobAegisName>{MobListRepoConsult(mob).AegisName} / {mob}</RoMobAegisName>
                        </RoMobName>
                    </RoMobHeader>

                    <RoMobBody>
                        <RoMobCollection src={"database/monster/" + MonsterMap(mob).toLowerCase() + ".gif"}/>

                        <RoMobColumnMaster>
                        
                            <MobInfoColumnA>
                                <MobPropertyContainer>
                                    <MobProperty>Nome</MobProperty>
                                    <MobPropertyValue>
                                        {MobListRepoConsult(mob).Name}
                                        <MonsterIcon
                                            img={Icon}
                                            onMouseOver={(event) => TipMouseOverEvent(event, `${typeTip}`, "rgba(200, 21, 21, 0.8)")}
                                            onMouseLeave={() => TipMouseOutEvent()}
                                            />
                                    </MobPropertyValue>
                                </MobPropertyContainer>

                                <MobPropertyContainer>
                                    <MobProperty>Level</MobProperty>
                                    <MobPropertyValue>{MobListRepoConsult(mob).Level}</MobPropertyValue>
                                </MobPropertyContainer>

                                <MobPropertyContainer>
                                    <MobProperty>HP</MobProperty>
                                    <MobPropertyValue>{formatNumber(parseInt(MobListRepoConsult(mob).Hp))}</MobPropertyValue>
                                </MobPropertyContainer>

                                <MobPropertyContainer>
                                    <MobProperty>ATK1</MobProperty>
                                    <MobPropertyValue>{formatNumber(parseInt(MobListRepoConsult(mob).Attack))}</MobPropertyValue>
                                </MobPropertyContainer>

                                <MobPropertyContainer>
                                    <MobProperty>ATK2</MobProperty>
                                    <MobPropertyValue>{formatNumber(parseInt(MobListRepoConsult(mob).Attack2))}</MobPropertyValue>
                                </MobPropertyContainer>

                                <MobPropertyContainer>
                                    <MobProperty>DEF</MobProperty>
                                    <MobPropertyValue>{MobListRepoConsult(mob).Defense}</MobPropertyValue>
                                </MobPropertyContainer>
                                <MobPropertyContainer>

                                    <MobProperty>MDEF</MobProperty>
                                    <MobPropertyValue>{MobListRepoConsult(mob).MagicDefense}</MobPropertyValue>
                                </MobPropertyContainer>

                                <MobPropertyContainer>
                                    <MobProperty>Precisão</MobProperty>
                                    <MobPropertyValue>{ parseInt(MobListRepoConsult(mob).Level) + 150 + parseInt(MobListRepoConsult(mob).Dex)}</MobPropertyValue>
                                </MobPropertyContainer>

                            </MobInfoColumnA>

                            <MobInfoColumnA>

                                <MobPropertyContainer>
                                    <MobProperty>Tipo</MobProperty>
                                    <MobPropertyValue>{MobListRepoConsult(mob).Race}</MobPropertyValue>
                                </MobPropertyContainer>

                                <MobPropertyContainer>
                                    <MobProperty>Tamanho</MobProperty>
                                    <MobPropertyValue>{MobListRepoConsult(mob).Size}</MobPropertyValue>
                                </MobPropertyContainer>

                                <MobPropertyContainer>
                                    <MobProperty>Elemento</MobProperty>
                                    <MobPropertyValue>{MobListRepoConsult(mob).Element} Lv.{MobListRepoConsult(mob).ElementLevel}</MobPropertyValue>
                                </MobPropertyContainer>

                                <MobPropertyContainer>
                                    <MobProperty>Walkspeed</MobProperty>
                                    <MobPropertyValue>{MobListRepoConsult(mob).WalkSpeed}</MobPropertyValue>
                                </MobPropertyContainer>

                                <MobPropertyContainer>
                                    <MobProperty>Alcance</MobProperty>
                                    <MobPropertyValue>{MobListRepoConsult(mob).AttackRange}</MobPropertyValue>
                                </MobPropertyContainer>

                                 <MobPropertyContainer>
                                    <MobProperty>Base EXP </MobProperty>
                                    <MobPropertyValue>{formatNumber(parseInt(MobListRepoConsult(mob).BaseExp))}</MobPropertyValue>
                                </MobPropertyContainer>

                                <MobPropertyContainer>
                                    <MobProperty>Job EXP </MobProperty>
                                    <MobPropertyValue>{formatNumber(parseInt(MobListRepoConsult(mob).JobExp))}</MobPropertyValue>
                                </MobPropertyContainer>

                                <MobPropertyContainer>
                                    <MobProperty>Esquiva </MobProperty>
                                    <MobPropertyValue>{parseInt(MobListRepoConsult(mob).Level) + 100 + parseInt(MobListRepoConsult(mob).Agi)}</MobPropertyValue>
                                </MobPropertyContainer>

                            </MobInfoColumnA>


                            <MobInfoColumnA>
                                <DemoRadarVisualisation
                                STR={MobListRepoConsult(mob).Str}
                                INT={MobListRepoConsult(mob).Int}
                                AGI={MobListRepoConsult(mob).Agi}
                                VIT={MobListRepoConsult(mob).Vit}
                                DEX={MobListRepoConsult(mob).Dex}
                                LUK={MobListRepoConsult(mob).Luk} />
                            </MobInfoColumnA>

                        </RoMobColumnMaster>

                    </RoMobBody>

                    <MonsterDropsContainer>
                            {MobDropListConsult(mob).map((drop) => {

                                let dropItemId = ItemAegisToIdConsult(drop.Item);

                                let itemInfo = ItemIdToNameAndResourceConsult(dropItemId);

                                if(itemInfo == null) {
                                    return
                                }

                                return(
                                    <DropContainer>
                                        <RoItemIcon img={CheckCorrupted(itemInfo.identifiedResourceName)}/>

                                        <ItemName>{itemInfo.identifiedDisplayName}</ItemName>
                                        <DropChance>({drop.Rate/100}%)</DropChance>
                                    </DropContainer>
                                ) 
                            })}
                    </MonsterDropsContainer>

                    <MvpDropsContainer>
                            {MvpDropListConsult(mob).map((drop) => {

                                let dropItemId = ItemAegisToIdConsult(drop.Item);

                                let itemInfo = ItemIdToNameAndResourceConsult(dropItemId);

                                if(itemInfo == null) {
                                    return
                                }

                                return(
                                    <DropContainer>
                                        <RoItemIcon img={CheckCorrupted(itemInfo.identifiedResourceName)}/>

                                        <ItemName>{itemInfo.identifiedDisplayName}</ItemName>
                                        <DropChance>({drop.Rate/100}%)</DropChance>
                                    </DropContainer>
                                ) 
                            })}
                    </MvpDropsContainer>

                    <DropsSectionContainer>
                        <SectionTitle>Mapas</SectionTitle>
                    </DropsSectionContainer>
                    
                    <MapSpawnContainer>
                            {MapaMonstro(mob).map((maps) => {

                                return(
                                    <MapItemContainer
                                     onMouseOver={(event) => {
                                        let linkImg = "database/maps/" + maps.location + ".png";

                                        if(maps.location.includes("Nenhum")) {
                                            linkImg = "database/maps/no_map.png";
                                        }

                                        setToolTipContent(<MapImage src={linkImg} />)
                                        MobTipMouseOverEvent(event, `${maps.location}  - (${maps.quantity})`, "rgba(0,0,0,1)"); }}

                                        onMouseLeave={() => {MobTipMouseOutEvent()}
                                        }
                                    >
                                        <MapName>{maps.location}</MapName>
                                        <SpawnAmount>({maps.quantity})</SpawnAmount>
                                    </MapItemContainer>
                                ) 
                            })}
                    </MapSpawnContainer>

                </RoMobMasterContainer>
                    )
                })}

                
        </MobListMasterContainer>

        <PaginationContainerIncrementer>
                 <IntervalPartitionIncrementer onClick={() => {
                    resetarScroll();

                    if(selectedInterval == 1) {
                        return
                    } else {
                        setSelectedInterval(selectedInterval - 1)
                    }
                    }}> ← 
                </IntervalPartitionIncrementer>
                <IntervalPartitionIncrementer onClick={() => {
                    resetarScroll();

                    if(selectedInterval > amountOfIntervals) {
                        return
                    } else {
                        setSelectedInterval(selectedInterval + 1)
                    }
                    }}> →
                </IntervalPartitionIncrementer>
            </PaginationContainerIncrementer>

        </DatabaseContainer>

    );
}

export default MobsDatabase;

const DatabaseContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 1100px;
    text-align: center;
    transition: 2s;
    margin-bottom: 50px;
    opacity: 1;
    //border: solid;

    @media (max-width: 1000px) {
    width: 90vw;
    margin-top: 30px;
    }

`;

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    //border: solid;
    margin-bottom: 10px;

    @media (max-width: 1000px) {
    width: 90%;
    //text-align: justify;
    margin-bottom: 50px;
    }
`;

const Title = styled.h1`
    font-size: 30pt;

    @media (max-width: 1000px) {
    font-size: 28pt;
    text-align: center;
    }
`;

const T1 = styled.div`
    width: 1000px;
    padding: 10px 20px;
    //border: solid;
    text-align: center;
    font-size: 13pt;


    @media (max-width: 1000px) {
    width: 100%;
    overflow: auto;
    padding: 10px;
    border-radius: 10px;
    //box-shadow: 0 0 10px 0 black;
    font-size: 11pt;
    }

`;

const SearchBarContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(0,0,0,.2);
    border-radius: 5px;
    padding: 10px 0;
    background-color:rgba(0,0,0,.5);

    @media (max-width: 1000px) {
    width: 90vw;
    flex-direction: column;
    padding: 10px;
    }

`

const Input = styled.input`
    font-size: 12pt;
    width: 500px;
    padding: 5px;
    height: 30px;
    border-radius: 5px;
    border: solid 0px;
    background-color: rgba(0, 0, 0, 0.4);
    text-align: center;
    margin: 0 10px;
    color: white;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    @media (max-width: 1000px) {
        width: 90vw;
        padding: 10px 0px;
        margin-right: 0px;
        margin-bottom: 10px;
    }
`

const CategoryContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    //border: solid;
    margin-right: 20px;

`

const CategoryItem = styled.div`
    background-image: url(${props => props.img});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 30px;
    height: 30px;
    transition: .2s ease-in-out;
    margin: 0 5px;
    border: solid 1px;
    filter: saturate(0);

    &:hover {
    filter: saturate(1);
    scale: 1.2;
    box-shadow: 2px 2px 2px 0 black;
    }

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        scale: 1;
        opacity: .5;
    }
`

const Submit = styled.div`
    font-size: 14pt;
    padding: 5px 5px;
    border-radius: 5px;
    border: solid 1px;
    background-color: rgba(5, 91, 144, 1);
    color: white;
    transition: .2s ease-in-out;
    margin: 0 10px;

    cursor: url('cursors0007.png'), pointer;

    &:hover {
        box-shadow: 0 0 5px 0 black;
        scale: 1.1;
    }

    &:active {
        cursor: url('cursors0008.png'), pointer;
        scale: .7;
        opacity: .5;
    }

    @media (max-width: 1000px) {
        display: flex;
        justify-content: center;
        width: 90vw;
        padding: 10px 0;
        margin-right: 0px;
        margin-top: 10px;
    }
        
`

const SubmitIcon = styled.div`
    background-image: url(${props => props.img});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 30px;
    height: 30px;
`

const SubTypeBarContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(0,0,0,.2);
    border-radius: 5px;
    padding: 10px;
    background-color:rgba(0,0,0,.5);
    margin-bottom: 50px;

    @media (max-width: 1000px) {
    width: 90vw;
    flex-direction: column;
    padding: 10px;
    }

`

const FilterSelect = styled.select`
    font-size: 12pt;
    width: 200px;
    padding: 5px;
    height: 40px;
    border-radius: 5px;
    border: solid 0px;
    background-color: rgba(0, 0, 0, 0.4);
    text-align: center;
    margin-right: 10px;
    color: white;
    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    @media (max-width: 1000px) {
    width: 90vw;
    margin-right: 0px;
    margin-bottom: 5px;
    }
`

const MiddleContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: end;
    width: 100%;
    margin-bottom: 30px;

    @media (max-width: 1000px) {
        width: 90vw;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
    }
`

const H1 = styled.span`
    font-size: 12pt;
    text-align: center;
    //font-weight: bold;

    //border: solid 1px;
    padding: 10px 20px;
    border-radius: 10px;
    background-color: rgba(5, 91, 144, .8);
    color: white;

`
const H2 = styled.span`
    font-size: 12pt;
    text-align: center;
    //font-weight: bold;
    //border: solid 1px;
    padding: 10px 20px;
    border-radius: 10px;
    background-color: rgba(18, 129, 22, 0.8);
    color: white;
    margin-right: 10px;

    @media (max-width: 1000px) {
        margin-bottom: 10px;
        margin-right: 0px;
    }

`

const H3 = styled.span`
    font-size: 12pt;
    text-align: center;
    //font-weight: bold;
    //border: solid 1px;
    padding: 10px 20px;
    border-radius: 10px;
    background-color: rgba(10, 9, 9, 0.8);
    color: white;
    margin-right: 10px;
    margin-left: 10px;

    @media (max-width: 1000px) {
        margin-bottom: 10px;
        margin-right: 0px;
    }

`

const MobListMasterContainer = styled.div`
    display: flex;
    width: 100%;
    //flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    //border: solid;

     @media (max-width: 1000px) {
        flex-direction: column;
        width: 95vw;
    }
`

const RoMobMasterContainer = styled.div`
    display: flex;
    flex-direction: column;
    //border: solid 1px;
    border-radius: 10px;
    width: 100%;
    transition: .2s ease-in-out;
    margin: 30px 0px;
    //box-shadow: 0 0 3px 0 black;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

    &:hover {
    //box-shadow: 0 0 5px 0px black;
    scale: 1.1;
    //margin: 30px 0px;
    z-index: 2;
    background-color: white;
    }

    @media (max-width: 1000px) {
    scale: .9;
    margin-bottom: 5px;

        &:hover {
            scale: 1;
        }
    }
`

const RoMobHeader = styled.div`
    display: flex;
    align-items: center;
    border-radius: 10px;
    //border: 1px solid rgba(0,0,0,.2);
    padding: 5px 0px;
    background-color:rgba(0, 0, 0, 0.8);
    border-radius: 5px;
    margin-bottom: 20px;
    width: 100%;

    @media (max-width: 1000px) {
        justify-content: center;
    }
    
`

const RoMobName = styled.div`
    display: flex;
    justify-content: start;
    flex-direction: column;
    padding: 10px 0px 10px 40px;
    color: rgba(255, 255, 255, 1);
    //border: solid;

    @media (max-width: 1000px) {
        justify-content: center;
        padding: 10px 0;
    }
    
`

const RoMobEnglishName = styled.div`
    display: flex;
    justify-content: start;
    font-size: 15pt;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    //border: solid;
    margin-bottom: 5px;

    @media (max-width: 1000px) {
        justify-content: center;
    }

    
`

const RoMobAegisName = styled.div`
    display: flex;
    width: 100%;
    justify-content: start;
    font-size: 9pt;
    text-decoration: italic;
    color: rgba(255, 255, 255, 1);
    //border: solid;
`

const RoMobBody = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    //border: solid 1px rgba(0,0,0,.2);
    justify-content: space-evenly;
    border-radius: 10px;

    @media (max-width: 1000px) {
        flex-direction: column;
        width: 95vw;
        padding: 5px
    }
`

const RoMobCollection = styled.img`
    //padding: 20px;
    border-radius: 10px;
    margin-right: 20px;
    //background-color: rgba(0,0,0,.5);
    //background-image: src(${props => props.img});
    //background-size: cover;
    //background-repeat: no-repeat;
    //background-position: center center;
    //width: 75px;
    //height: 100px;
    //box-shadow: 2px 2px 0 0 rgba(0,0,0,.2);

    @media (max-width: 1000px) {
        scale: 1.5;
        margin: 30px 0px;
    }
`

const RoMobColumnMaster= styled.div`
    display: flex;
    justify-content: space-evenly;
    //padding: 20px;
    //border: solid 1px;

    @media (max-width: 1000px) {
        flex-wrap: wrap;
        align-items: center;
        width: 95vw;
        //padding: 5px
    }
`

const MobInfoColumnA = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 10px;
    //border: 1px solid;
    min-width: 230px;
`
const MobPropertyContainer = styled.div`
    display: flex;
    padding: 0px;
    align-items: center;
    justify-content: start;
    //border: 1px solid;
    width: 100%;
`

const MobProperty = styled.div`
    display: flex;
    padding: 5px;
    align-items: center;
    justify-content: start;
    font-weight: bold;
    font-size: 12pt;
    width: 120px;
    //border: 1px solid;
`

const MobPropertyValue = styled.div`
    display: flex;
    padding: 5px 0;
    align-items: center;
    justify-content: start;
    width: 100%;
    font-size: 12pt;
    min-width: 120px;
    //border: solid;
    margin-left: 10px;
`

const MonsterIcon = styled.div`
    background-image: url(${props => props.img});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 35px;
    height: 35px;
    //border: solid;
    transition: .3s ease-in-out;
    
`

const CardImage = styled.div`
    background-image: url('/database/cardbmp/${props => props.img}.bmp');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 350px;
    height: 470px;
    box-shadow: 0 0 10px 0px black;
    border: solid 1px;
    z-index: 30;

    @media (max-width: 1000px) {
    width: 600px;
    height: 800px;
    }


`

const SlotsContainer = styled.div`
    //border: solid 1px rgba(0,0,0,.2);
    border-radius: 10px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: start;
    padding-left: 5px;
`

const Slot = styled.div`
    background-image: url('${props => props.img}');
    background-size: cover;
    background-repeat: no-repeat;
    backrgound-position: center center;
    width: 24px;
    height: 24px;

`

const MonsterDropsContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    flex-wrap: wrap;
    padding: 5px;
    width: 100%;
    //border: solid 1px;
    transition: .3s ease-in-out;
    margin-top: 10px;

    &:hover {
    height: 100%;
    }

    @media (max-width: 1000px) {
        width: 95vw;
        padding: 5px 0px;
        //flex-direction: column;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
    
    }

`

const MvpDropsContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    flex-wrap: wrap;
    padding: 5px;
    width: 100%;
    //border: solid 1px;
    transition: .3s ease-in-out;
    margin-top: 10px;
    

    &:hover {
    height: 100%;
    }

    @media (max-width: 1000px) {
        width: 95vw;
        padding: 5px 0px;
        //flex-direction: column;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
    
    }

`

const DropContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 15px;
    //border: solid 1px;
    border-radius: 10px;
    margin: 2px 30px 2px 0px;
    font-size: 10pt;
    transition: .3s ease-in-out;

    &:hover {
    scale: 1.1;
    z-index: 5;

    background-color: rgba(0, 0, 0, .7);
    color: white;
    }
`

const RoItemIcon = styled.div`
    background-image: url('/database/itemPng/${props => props.img}.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 25px;
    height: 25px;
    margin: 0 22px 0 0;
    
`

const ItemName = styled.span`
    
`
const DropChance = styled.span`
    font-weight: bold;
    margin-left: 5px;
`

const DropsSectionContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    width: 100%;
    padding: 0px 0px 0 0px;

`
const SectionTitle = styled.span`
    display: flex;
    padding: 5px 20px;
    font-size: 10pt;
    font-weight: bold;
    justify-content: start;
    align-itens: center;
    //border-bottom: 1px solid black;
    border-radius: 5px;
    color: white;
    background-color: rgba(7, 7, 7, 0.5);
    margin-top: 30px;

`

const MapSpawnContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    flex-wrap: wrap;
    padding: 5px 0;
    width: 100%;
    //border: solid 1px;
    transition: .3s ease-in-out;
    margin-top: 5px;
    

    &:hover {
    height: 100%;
    }

    @media (max-width: 1000px) {
        width: 95vw;
        padding: 5px 0px;
        //flex-direction: column;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
    
    }

`

const MapItemContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 5px;
    //border: solid 1px;
    border-radius: 5px;
    margin: 2px 30px 2px 0px;
    font-size: 10pt;
    transition: .3s ease-in-out;
    

    &:hover {
    scale: 1.1;
    z-index: 5;

    background-color: rgba(0, 0, 0, .7);
    color: white;
    }
`

const MapName = styled.span`
    
`
const SpawnAmount = styled.span`
    font-weight: bold;
    margin-left: 5px;
`


const MobImage = styled.img`
    border-radius: 10px;
    padding: 20px;
    scale: 1.3;
    margin-bottom: 30px;
    background-color: rgba(0, 0, 0, .7);
    border: solid 1px;
    box-shadow: 5px 5px 5px 0 rgba(0,0,0,.7);
`


const MapContainer = styled.div`
    display: flex;
    align-itens: center;
    justify-content: space-evenly;
    flex-wrap: wrap;
    max-width: 500px;
    background-color: rgba(0, 0, 0, .7);
    border: solid 1px;
    box-shadow: 5px 5px 5px 0 rgba(0,0,0,.7);
    border-radius: 10px;
    padding: 20px;
    }
`



const MapTitle = styled.span`
    font-size: 17pt;
    text-align: center;
    margin-bottom: 10px;

`

const MapContainerItem = styled.div`
    display: flex;
    flex-direction: column;
    align-itens: center;
    justify-content: center;
    //border: solid 1px;
    border-radius: 10px;
    font-size: 14pt;
    margin: 0 10px;
    color: white;
    transition: .3s ease-in-out;
`

const MapImage = styled.img`
    width: 250px;
    height: 250px;
    margin-right: 10px;
    background-color: rgba(0,0,0,.0);
    border-radius: 5px;
    margin-bottom: 20px;
`

const PaginationContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    width: 100%;
    margin-bottom: 0px;
    flex-wrap: wrap;
    overflow-y: auto;
    max-height: 100px;
    padding: 10px 10px;
    //border: 1px solid rgba(0,0,0,.1);
    background-color: rgba(0,0,0,.5);
    border-radius: 5px;

    @media (max-width: 1000px) {
        width: 90vw;
        //flex-direction: column;
        align-items: center;
        justify-content: start;
    }
`

const IntervalPartition = styled.div`
    border-radius: 5px;
    background-color: rgba(0,0,0,.7);
    color: white;
    padding: 5px 10px;
    margin-right: 5px;
    margin-bottom: 5px;
    transition: .2s ease-in-out;
    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        scale: .5;
        opacity: .5;
    }

    &:hover {
        box-shadow: 0 0 2px 0px black;
        scale: 1.1;
        z-index: 2;
        background-color: rgba(144, 5, 5, 1);
    }
`

const PaginationContainerIncrementer = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    width: 100%;
    margin-bottom: 0px;
    flex-wrap: wrap;
    overflow-y: auto;
    max-height: 95px;
    padding: 10px;

    @media (max-width: 1000px) {
        width: 90vw;
        //flex-direction: column;
        align-items: center;
        justify-content: center;
    }
`

const IntervalPartitionIncrementer = styled.div`
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    padding: 5px 10px;
    margin-top: 20px;
    margin-bottom: 5px;
    margin-right: 10px;
    transition: .2s ease-in-out;
    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

    &:hover {
    box-shadow: 0 0 2px 0px black;
    scale: 1.5;
    z-index: 2;
    background-color: rgba(0,0,0,.8);
    }
`